
let _ = require('../_.js');
let $ = jQuery;

let auction_active = false;
let chat_active = false;
let chat_open = false;

let conversation = null;
let broadcast_conversation = null;

let conversation_subscription = null;
let broadcast_conversation_subscription = null;

let conversation_messages = [];
let broadcast_conversation_messages = [];

let received_initial_messages_user = false;
let received_initial_messages_broadcast = false;

let has_unseen_message;
let unseen_message_count;
let last_seen_broadcast_id = null;

_.AuctionUI_Chat = class AuctionUI_Chat {

    static async init() {

        // if (!_.ac_state.auction.is_online_auction) {
        //     return;
        // }

        _.AuctionUI_Chat.load_state();

        _.AuctionUI_Data.on_data_update("auction.status", async function () {
            await _.AuctionUI_Chat.refresh_chat();
        });

        await _.AuctionUI_Chat.refresh_chat();

        _.AuctionUI_Chat.chatbox_hooks();

        $("#chatbox").on('mousemove click keypress', _.AuctionUI_Chat.mark_chat_messages_seen);

        // Blink title on new message
        let originalTitle = document.title;
        setInterval(function () {
            // Check if any elements with class clerk-chat-button-new-messages are visible,
            // This indicates an unread message
            if (has_unseen_message) {
                if (unseen_message_count == 1) {
                    document.title = "-- (1) UNREAD MESSAGE --";
                } else {
                    document.title = "-- (" + unseen_message_count + ") UNREAD MESSAGES --";
                }
                // After 2 seconds, revert to the original document title
                setTimeout(function () {
                    document.title = originalTitle;
                }, 2000);
            }
        }, 4000); // Check every 2 seconds
    }

    static async session_updated_handler() {
        _.AuctionUI_Chat.refresh_chat();
    }

    static async chat_error(message) {
        $("#chatbox-messages-container").hide();
        $("#chatbox-error-fatal").show();
        $("#chatbox-error-fatal-message")
            .empty()
            .append($("<div style='font-weight:bold; margin-bottom: 25px;'>A fatal error has occurred:</div>"))
            .append($("<div style='font-weight:bold; color:red;'></div>").text(message));
        console.error(message);
    }

    static chat_show(focus = false) {
        $("#chatbox").show();
        if (focus) {
            $("#chat-message-input").focus();
            $("#chatbox-messages").scrollTop($("#chatbox-messages").prop('scrollHeight'));
        }
        _.ui_update();
        _.AuctionUI_Chat.save_state();
    }

    static chat_hide() {
        $("#chatbox").hide();
        _.ui_update();
        _.AuctionUI_Chat.save_state();
    }

    // Refreshes the conversation objects, the parent node for all the conversations in chat.
    // This gets called when auction status changes, or login status changes.  It may change if the chat is enabled or not.
    static async refresh_chat() {
        // Skip chat refresh if not on an auction page
        if (!_.ac_state.auction || !_.ac_state.auction.id) {
            console.log("Skipping chat refresh - not on auction page");
            return;
        }

        await _.mutex('_refresh_chat', async function () {

            // $(".chatbox-header-text").text("");

            // Ensure chat is enabled for this auction.

            // let auction = _.ac_state.auction;
            // if (auction.status == App_Models_Auction.STATUS_PUBLISHED || auction.status == App_Models_Auction.STATUS_ACTIVE) {
            //     auction_active = true;
            // } else {
            //     auction_active = false;
            // }

            $("#chat-container").show();

            // Get the 'broadcast' conversation.

            if (!broadcast_conversation) {
                let broadcast_conversation_id;
                try {
                    broadcast_conversation_id = (await _.backend_ajax('chat', 'user_auction_chat_get_broadcast_conversation', {
                        auction_id: _.ac_state.auction.id
                    })).conversation_id;
                } catch (error) {
                    console.error("Broadcast conversation error:", error);
                    _.AuctionUI_Chat.chat_error("There was an error retrieving the conversation for the chat.");
                    return;
                }
                if (broadcast_conversation_id) {
                    // console.log(broadcast_conversation_id);
                    broadcast_conversation = await App_Models_ChatConversation.get(broadcast_conversation_id);
                    // console.log(broadcast_conversation);
                }
            }

            if (!broadcast_conversation_subscription && broadcast_conversation) {
                // Subscribe to updates
                broadcast_conversation_subscription = broadcast_conversation.subscribe('messages', _.AuctionUI_Chat.on_broadcast_chat_messages);
            }

            // Check registrant sign in.
            // Reset private conversation subscription if it is invalid.
            let registrant = await _.AuctionUI_Session.get_registrant();
            let registrant_id = registrant ? registrant.id : null;

            // Reset conversation object if it is invalid
            if (!conversation || conversation.registrant_id != registrant_id) {
                if (conversation_subscription && conversation_subscription.unsubscribe) {
                    conversation_subscription.unsubscribe();
                    conversation_subscription = null;
                }
                conversation = null;
                conversation_messages = [];
            }

            // Register the private conversation if signed in as a registrant (not backend user).
            if (registrant) {
                if (!conversation || conversation.registrant_id != registrant_id) {
                    let conversation_id;
                    try {
                        conversation_id = (await _.backend_ajax('chat', 'user_auction_chat_get_conversation', {
                            auction_id: _.ac_state.auction.id
                        })).conversation_id;
                    } catch (error) {
                        console.error("Private conversation error:", error);
                        _.AuctionUI_Chat.chat_error("There was an error retrieving the conversation for the chat.");
                        return;
                    }
                    if (conversation_id) {
                        conversation = await App_Models_ChatConversation.get_private(conversation_id);
                    }
                }

                if (!conversation) {
                    _.AuctionUI_Chat.chat_error("There was an error retrieving the conversation for the chat.");
                    return;
                }

                // Subscribe to updates - this will trigger the function call almost right away.
                if (!conversation_subscription) {
                    conversation_subscription = conversation.subscribe('messages', _.AuctionUI_Chat.on_chat_messages);
                }
            }

            // Get 'private' conversation.
            chat_active = true;

            $("#chatbox-loading").hide();
            $("#chatbox-error-fatal").hide();
            $("#chatbox-not-messages-container").hide();
            $("#chatbox-messages-container").show();
        });
    }

    static on_chat_messages(messages) {

        // Todo: open for unread messages, mark read.
        conversation_messages = messages;
        _.AuctionUI_Chat.redraw_messages();

        // These are global variables.  (sloppy code)
        // We also use these in the code to display the blinking page title.
        has_unseen_message = false;
        unseen_message_count = 0;

        for (let i in messages) {
            if (!messages[i].user_seen_at && !messages[i].sender_is_web) {
                has_unseen_message = true;
                unseen_message_count++;
            }
        }

        if (has_unseen_message) {
            _.AuctionUI_Chat.chat_show();
            // _.AuctionUI_Chat.mark_chat_messages_seen();
        }
    }

    static async on_broadcast_chat_messages(messages) {
        // Open for all unseen messages.

        let is_unseen_broadcast_message = false;
        if (_.ac_state.auction && _.ac_state.auction.auction_status == App_Models_Auction.STATUS_ACTIVE) {
            for (let m of messages) {
                if (last_seen_broadcast_id === null || last_seen_broadcast_id < m.id) {
                    is_unseen_broadcast_message = true;
                    last_seen_broadcast_id = m.id;
                }
            }
        }

        if (!received_initial_messages_broadcast && !is_unseen_broadcast_message) {
            setTimeout(function () {
                received_initial_messages_broadcast = true;
            }, 3000);
        } else {
            _.AuctionUI_Chat.chat_show();
        }

        broadcast_conversation_messages = messages;
        _.AuctionUI_Chat.redraw_messages();
    }

    // static async redraw_live() {
    //     await _.mutex('_redraw_messages', async function () {
    //         let has_new_message = false;
    //         let $container = $("#ac-gallery-activity");
    //         let all_messages = [...broadcast_conversation_messages, ...activity_messages];
    //     });
    // }

    static async redraw_messages() {
        await _.mutex('_redraw_messages', async function () {
            let has_new_message = false;

            let $container = $("#chatbox-messages");

            let $private_message_notice = $container.component(-1, 'default', { sort_id: -1, 'direction': 'asc' });
            $private_message_notice
                .text("This is a private conversation between yourself and the LandProz Auction Manager for this auction.")
                .attr("style", "margin-bottom: 10px; color: black; font-size: 13px; font-weight: bold; padding: 8px; border: 1px solid #555;");

            let all_messages = [...broadcast_conversation_messages];  // Quick shallow copy

            if (conversation && conversation_messages) {
                all_messages = all_messages.concat([...conversation_messages]);
            }

            let last_timestamp = null;

            for (let i in all_messages) {
                let item = all_messages[i];
                let $component = $container.component(item.id, 'default', { sort_id: item.id, 'direction': 'asc' });
                let chash = $component.data('chash');

                if (!chash) {
                    has_new_message = true;
                }

                let hash = await item.hash();

                let show_timestamp = false;

                let time = new _.TimeManager().new(item.created_at_localized);
                if (last_timestamp == null || last_timestamp < time.unix() - (60 * 5)) {
                    show_timestamp = true;
                    last_timestamp = time.unix();
                }

                // Only redraw as necessary, this could get pointlessly expensive if we redraw every single time there is a message
                if (chash != hash) {
                    // Data is new or has changed.
                    $component.data('chash', hash);

                    $component.empty();

                    if (item.deleted) {
                        $component.remove();
                    } else {
                        let conversation = await item.conversation.fetch_private();


                        // Show timestamp every 5 minutes.
                        if (show_timestamp) {
                            $component
                                .append($("<span style='color: gray; font-size: 12px;'></span>").text(time.human()))
                                .append($("<br />"));
                            last_timestamp = time.unix();
                        }

                        if (conversation.is_broadcast) {
                            $component
                                .append($("<span style='color: darkgreen; font-weight: bold'>Broadcast Message:&nbsp;</span>"))
                                .append($("<span style='color: black; font-weight: bold'></span>").text_with_br(item.message));
                        } else if (item.sender_is_web) {
                            $component
                                .append($("<span style='color: darkgreen; font-weight: bold'>(Private) You:&nbsp;</span>"))
                                .append($("<span style='color: darkgreen'></span>").text_with_br(item.message));
                        } else if (!item.sender_is_clerk) {
                            $component
                                .append($("<span style='color: darkblue; font-weight: bold'>(Private) Auction Manager:&nbsp;</span>"))
                                .append($("<span style='color: black'></span>").text_with_br(item.message));
                            // .append($("<span style='color: black'></span>").text(item.message));
                        } else {
                            $component
                                .append($("<span style='color: darkblue; font-weight: bold'>(Private) Clerk:&nbsp;</span>"))
                                .append($("<span style='color: black'></span>").text_with_br(item.message));
                        }
                    }
                }
            }

            if (has_new_message) {
                // Scroll to bottom
                $container.scrollTop($container.prop('scrollHeight'));
            }
        });
    }

    static async send_message() {
        let message = $("#chat-message-input").val().trim();

        if (message !== "") {
            if (!conversation) {
                // Delay this a quarter second to clear key buffer
                setTimeout(function () {
                    _.AuctionUI_Auction_General_UI.show_dialog_account_required_if_not_logged_in("You are not signed in, please create an\n account or sign in to chat to land agents:", async function () {
                        _.AuctionUI_Chat.chat_show(true);
                    });
                }, 250);
            } else {

                $("#chat-message-input").val('');
                _.AuctionUI_Chat.save_state();

                // Todo: Show message in textbox, replace it with server version once rendered.
                await _.mutex('_send_message', async function () {
                    try {
                        await _.backend_ajax('chat', 'user_auction_chat_new_message', {
                            auction_id: _.ac_state.auction.id,
                            message: message
                        });
                    } catch (error) {
                        $("#chat-message-input").val(message);
                        await _.flash_alert("An error has occured sending your message, please try again.", 'danger');
                    }
                });
            }
        }
    }

    // Sends to server that the user has seen the chat messages.
    // This will be seen by the clerk (todo).
    static async mark_chat_messages_seen() {
        if ($("#chatbox").is(":visible") && await _.AuctionUI_Session.get_registrant() && has_unseen_message) {
            if (!_.AuctionUI_Chat._mark_chat_messages_seen_debounce) {
                _.AuctionUI_Chat._mark_chat_messages_seen_debounce = _.debounce(2000, async function () {
                    await _.backend_ajax('chat', 'user_auction_chat_mark_seen', {
                        auction_id: _.ac_state.auction.id,
                    });
                });
            }
            _.AuctionUI_Chat._mark_chat_messages_seen_debounce();
        }
    }

    static chatbox_hooks() {
        $("body").append($("#chat-container"));

        // Hide chatbox on minimize button
        $(".chatbox-header-btn-minimize").click(_.AuctionUI_Chat.chat_hide);

        // Toggle chatbox
        $(".ac-btn-action-chat").click(function () {
            if ($("#chatbox").is(":visible")) {
                _.AuctionUI_Chat.chat_hide();
            } else {
                _.AuctionUI_Chat.chat_show(true);
            }
        });

        // Send a message when "Enter" is pressed
        $("#chat-message-input").on('keypress', function (e) {
            if (e.which == 13) {
                e.preventDefault();  // Prevent default to stop the form submission
                _.AuctionUI_Chat.send_message();
            }
        });

        // Send a message when the "Send" button is clicked
        $("#send-button").click(_.AuctionUI_Chat.send_message);

        // Hook login button
        $(".ac-btn-chat-action-sign-in").click(function () {
            _.AuctionUI_Login.login_modal(function () {
                chat_show(true);
            });
        });

        // Hook input events to save state
        $("#chat-message-input").on('keyup', _.AuctionUI_Chat.save_state);
        $("#chat-message-input").on('focus', _.AuctionUI_Chat.save_state);
        $("#chat-message-input").on('blur', _.AuctionUI_Chat.save_state);
    }

    // Save the state of the chatbox so it reopens on page refresh.
    static save_state() {
        let auction_id = _.AuctionUI.auction_id();

        let state = {
            is_open: $("#chatbox").is(":visible"),
            message: $("#chat-message-input").val(),
            has_focus: $("#chat-message-input").is(":focus"),
            last_seen_broadcast_id: last_seen_broadcast_id
        }

        localStorage.setItem('auction-chat-pref-' + auction_id, JSON.stringify(state));
    }

    // Get and restore previous chat state for this auction
    static load_state() {
        let auction_id = _.AuctionUI.auction_id();
        let pref_json = localStorage.getItem('auction-chat-pref-' + auction_id);

        if (pref_json) {
            let state = JSON.parse(pref_json);
            if (!state) {
                return;
            }
            if (state.is_open) {
                $("#chatbox").show();
            }
            if (state.message) {
                $("#chat-message-input").val(state.message);
            }
            if (state.has_focus) {
                $("#chat-message-input").focus();
            }
            if (state.last_seen_broadcast_id) {
                last_seen_broadcast_id = state.last_seen_broadcast_id;
            }

            return true;
        } else {
            return false;
        }
    }
}
